export const GetClientsShortData = `query {
  getClients {
    id
  }
}`;

export const GetAllPayers = `query {
  getAllPayers {
    payer_id
    names
  }
}`;

export const GetPracticeTimeZone = `query getPracticeDetails {
  getPracticeDetails{
    timezone,
    email,
  }
}`;


export const GetClients = `query {
    getClients {
      therapistId
      id
      username
      status
      active
      gender
      dateOfBirth
      sendEmailReminder
      contact{
      phone
      type
      email
      }
      personalDetail {
        first
        middle
        last
        suffix
        nickname
      }
      address{
        city
        line1
        line2
        state
        zip
      }
    }
  }`;

export const GetBillingSettings = `query getBillingSettings {
  getBillingSettings{
       therapistId,
    updatedAt,
    setting{
      currency,
      taxId,
      organizationNPI,
      invoicePastDue{
        days,
        sendEmail
      }
    },
    address{
      street,
      city,
      state,
      zip,
      unitBilling
    },
    invoiceSetting{
      defaultText,
      automateOn
    },
    superBillGeneration{
      days
    },
    deliveryDelay{
      numMinutes
    },
    billingClientDocument{
      monthlyStatements,
      monthlySuperBills,
      emailNotification
    },
    autoplay
  }
}`;

export const GetPracticeDetails = `query getPracticeDetails {
  getPracticeDetails{
      therapistId,
    updatedAt,
    name,
    timezone,
    email,
    phone{
      number
      type
    },
    locations{
      name,
      street,
      city,
      zip,
      state,
      insurancePlaceOfService
    },
    telehealthOffice{
      name,
      address{
        street,
        city,
        zip,
        state
      }
      insurancePlaceOfService
    },
    cancellationPolicy
  }
}`;

export const GetInsuranceSetting = `query getInsuranceSetting {
  getInsuranceSetting{
    therapistId
    updatedAt
    providerInfo{
      type
      practiceDefault
      firstName
      middleName
      lastName
      practiceName
      street
      city
      state
      zip
      npi
      taxonomyCode
    }
    serviceLocation{
      includeInClaim
    }
    superBillSetting{
      multipleDiagnosis
    }
  }
}`;

export const GetSubscriptionDue = `query {
  getTherapist {
    subscriptionDue
    isOnTrial
    customerId
  }
}`;

export const GetProviderPlans = `query {
  getProviderPlans {
    amount
    custom
    planId
    interval
    intervalCount
    name
    planRef
    videoFeatureAmount
    additionalClinicianAmount
  }
}`;

export const GetCurrentPlans = `query {
  getCurrentPlan {
    subscriptionId
    subscriptionDue
    planId
    planRef
    planName
    isOnTrial
  }
}`;


export const GetPaymentHistory = `query {
  getPaymentHistory {
    customerId
    eventId
    amount
    createdAt
    planName
    status
    subscriptionId
    invoiceId
    invoicePdf
    invoiceUrl
  }
}`;

export const GetAllClientAppointmentsQuery = `query getAllClientAppointments($clientId: String!, $therapistId: String!) {
  getAllClientAppointments(clientId: $clientId, therapistId: $therapistId) {
    id
    active
    duration {
      allDay
      start
      end
    }
    status
    conversationId
    email
    appointmentBy
    appointmentFor
    individual
    active
    services{
    serviceCode
    serviceName
    serviceAmount
    }
    progressNoteId
    status
    repeat
    officeLocation
  }
}`;

export const GetVideoToken = `query {
  getVideoToken {
    identity
    token
  }
}`;

export const getTherapistProfile = `query {
  getTherapist{
    id
    name {
      first
      last
    }
    photo {
      s3path
    }
    title_block {
      title
      titleDesc
    }
    works_with {
      ages
      concerns
      ethnicity
      groups
      mental_health
    }
    insurance
    modality
    specialty
    types_of_therapy
    sexuality
    finance {
      fee {
        min
        max
      }
      payment_method
    }
    phone
    website
    bio
    second_title
    religion
    languages
    additionalLocations {
      city
      # country
      line1
      line2
      state
      zip
      phone
    }
    address {
      city
      # country
      line1
      line2
      state
      zip
    }
    qualifications {
      board_certifications
      experience
      graduation_year
      license_num
      license_state
      school
    }
    supportGroups {
      description
      title
      details {
        finance {
          fee {
            max
            min
          }
        }
        types_of_therapy
        works_with {
          ages
          concerns
        }
      }
      location {
        name
        address {
          city
        #  country
          line1
          line2
          state
          zip
        }
      }
    }
  }
}`;

export const GetProgessNoteMetadata = `query {
  getProgessNoteMetadata {
    key
    name
    type
    multiple
    elements {
      name
      key
      type
      options
      placeholder
      placeholder
      required
      details{
        name
        key
        type
        options
        required
        details {
          key
          name
          type
        }
      }
      instruction
    }
  }
}`;

export const CreatePGNote = `mutation createProgressNote($appointmentId: String!, $date: String!, $input: ProgressNoteInput!) {
  createProgressNote(appointmentId: $appointmentId, input: $input, date: $date) {
    clientId
  }
}`;

export const EditPGNote = `mutation editProgressNote($id: String!, $input: ProgressNoteInput!) {
  editProgressNote(id: $id, input: $input) {
    clientId
  }
}`;


export const GetClientInsurance = `query getClientInsurance($clientId: String!) {
  getClientInsurance(clientId: $clientId) {
    billingType
    autogenerateBillingDocs {
      statements
      superBills
    }
    emailBillingNotifications
    insuranceInfo {
      insuranceType
      primaryInsured {
        insured
        info {
          name {
            first
            last
            full
          }
          address {
            city
            line1
            line2
            state
            zip
          }
          phone
          gender
          dob
        }
      }
      insurancePayer
      address {
            city
            line1
            line2
            state
            zip
          }
      memberId
      planId
      groupId
      coPay
      forSuperbillsSendPaymentTo
      deductible
      insurancePayerPhone
      insurancePayerFax
      employerOrSchool
      insuranceCardOnFile
    }
    authorizationTracking {
      priorAuthorizationNumber
      validFrom {
        start
        end
      }
      numberOfUses
      active
      reminder
    }
    additionalClaims
    additionalClaimsInfo {
      acceptAssignment
      patientConditionRelation {
        employment
        autoAccident
        autoAccidentState
        otherAccidents
      }
      dateOfCurrentIllnessOrInjury
      datesPatientUnableToWork {
        start
        end
      }
      hospitalDatesRelatedToServices {
        start
        end
      }
      referingProvider
      outsideLab
      labCharges
      clientAccountNumber
    }
    clientDefaultServices {
      service
      amount
      default
    }
  }
}`;

export const UpdateClientInsurance = `mutation updateClientInsurance($clientId: String!, $input: ClientInsuranceInput!) {
  updateClientInsurance(clientId: $clientId, input: $input) {
    billingType
  }
}`;

export const GetServicesOffered = `query getServicesOffered {
  getServicesOffered{
     services{
      service,
      rate
      description
    }
  }
}`;

export const GetTherapistProfile = `query {
getTherapist{
    id
    hasPartialData
    email
    name {
      first
      last
      full
    }
     address {
          line1
          line2
          city
          state
          zip
      }
    organization
    insuranceSetting {
      npi
      taxonomyCode
    }
    photo {
      s3path
    }
    title_block {
      title
      titleDesc
    }
    works_with {
      ages
      concerns
      ethnicity
      groups
      mental_health
    }
    insurance
    modality
    specialty
    types_of_therapy
    sexuality
    finance {
      fee {
        min
        max
      }
      payment_method
    }
    phone
    website
    bio
    second_title
    religion
    languages
    additionalLocations {
      city
      line1
      line2
      state
      zip
      phone
    }
  
    qualifications {
      board_certifications
      experience
      graduation_year
      license_num
      license_state
      school
    }
    supportGroups {
      description
      title
      details {
        finance {
          fee {
            max
            min
          }
        }
        types_of_therapy
        works_with {
          ages
          concerns
        }
      }
      location {
        name
        address {
          city
          line1
          line2
          state
          zip
        }
      }
    }
  }

}`;

export const GetInsurancePayer = `query {
  getInsurancePayer{
    payerId
    address{
      line1
      line2
      city
      state
      zip
    }
  }
}`;

export const GetProviderPayerEnrollments = `query {
  getPayerListEnrollments
}`;

export const EnrollProviderToPayerList = `mutation enrollProviderToPayerList($payerId: String!, $eligibleId: String!){
  enrollProviderToPayerList(payerId: $payerId, eligibleId: $eligibleId) {
    status
    message
  }
}`;

export const GetNewCoverage = `query getNewCoverage($clientId: String!){
  getNewCoverage(clientId: $clientId) {
    therapistId
    clientId
    coverages
  }
}`;

export const GetCoverage = `query getCoverage{
  getCoverage {
    clientName
    clientId
    coverages
  }
}`;

export const CheckClientInsurance = `query getClientInsurance($clientId: String!) {
  getClientInsurance(clientId: $clientId) {
    insuranceInfo {
      insuranceType
    }
  }
}`;

export const CheckUserStatus = `mutation checkUserStatus($email: String!) {
  checkUserStatus(email: $email) {
    status
    message
    user {
      id
      email
      firstName
      lastName
      phone
    }
  }
}`;

export const EditGroupMutation = `mutation editGroup($groupId: String!, $input: GroupInput!) {
  editGroup(input: $input, groupId: $groupId) {
    id
	  therapy
      app
      type
      name
    location {
        name
        address
        city
        state
        zip
      }
  }
}`;

export const GetClientInsuranceInfo = `query getClientInsurance($clientId: String!) {
  getClientInsurance(clientId: $clientId) {
    billingType
    insuranceInfo {
      insuranceType
      primaryInsured {
        insured
        info {
          name {
            first
            last
            full
          }
          address {
            city
            line1
            line2
            state
            zip
          }
          phone
          gender
          dob
        }
      }
      insurancePayer
      address{
      city
      line1
      line2
      state
      zip
      }
      memberId
      planId
      groupId
      coPay
      forSuperbillsSendPaymentTo
      deductible
      insurancePayerPhone
      insurancePayerFax
      employerOrSchool
      insuranceCardOnFile
    }
    additionalClaimsInfo {
      patientConditionRelation {
        employment
        autoAccident
        autoAccidentState
        otherAccidents
      }
    }
  }
}`;

export const GetTemplateLibraryMetadata = `query {
  getTemplateLibraryMetadata {
    formName
    description
    questionnaires {
      questionType
      questions {
        question
        type
        required
        multiple
        options {
          key
          value
        }
      }
    }
  }
}`;

export const GetShortTemplateLibraryMetadata = `query {
  getTemplateLibraryMetadata {
    formName
    description
    questionnaires{
        questionType
        questions{
            question
            type
            required
            multiple
            options{
                key 
                value
            }
        }
    }
  }
}`;

export const GetTherapistIntakeFormSettings = `query {
  getTherapistIntakeFormSettings {
    updatedAt
    intakeForm {
      formName
      default
    }
  }
}`;

export const SetTherapistIntakeFormSettings = `mutation setTherapistIntakeFormSettings($formName: String!) {
  setTherapistIntakeFormSettings(formName: $formName) {
    status
    message
  }
}`;

export const RemoveTherapistIntakeFormSettings = `mutation removeTherapistIntakeFormSettings($formName: String!) {
  removeTherapistIntakeFormSettings(formName: $formName) {
    status
    message
  }
}`;

export const AddClientPortal = `mutation addClientPortal($name: String!, $providerId: String!) {
  addClientPortal(name: $name, providerId: $providerId) {
    status
    message
  }
}`;

export const GetClientPortalDetails = `query {
  getClientPortalDetails {
    name
    updatedAt
  }
}`;

export const SetTherapistIntakeFormSettingsDefault = `mutation setTherapistIntakeFormSettingsDefault($formName: String!, $default: Boolean!) {
  setTherapistIntakeFormSettingsDefault(formName: $formName, default: $default) {
    status
    message
  }
}`;

export const GetConsentDocuments = `query {
  getConsentDocuments {
    userId
    id
    title
    details
    included
    createdAt
    updatedAt
  }
}`;

export const AddConsentDocument = `mutation addConsentDocument($title: String!, $details: String!) {
  addConsentDocument(title: $title, details: $details) {
    status
    message
  }
}`;

export const EditConsentDocument = `mutation editConsentDocument($id: String!, $title: String!, $details: String!, $included: Boolean!) {
  editConsentDocument(id: $id, title: $title, details: $details, included: $included) {
    status
    message
  }
}`;
export const LogUserAuthEvent = `mutation logUserAuthEvent($event: AuthLog!) {
  logUserAuthEvent(event: $event) {
    status
    message
  }
}`;
export const LogHipaaAuditEvent = `mutation logHipaaAuditEvent($event: String!,$clientId: String!) {
  logHipaaAuditEvent(event: $event,clientId: $clientId) {
    status
    message
  }
}`;

export const DeleteConsentDocument = `mutation deleteConsentDocument($id: String!) {
  deleteConsentDocument(id: $id) {
    status
    message
  }
}`;

export const ShareClientDocuments = `mutation shareClientDocuments($clientId: String!, $documents: [ClientDocumentInput!]!, $emailText: String!) {
  shareClientDocuments(clientId: $clientId, documents: $documents, emailText: $emailText) {
    status
    message
  }
}`;

export const GetClientDocuments = `query getClientDocuments($therapistId: String!, $clientId: String!) {
  getClientDocuments (therapistId: $therapistId, clientId: $clientId) {
    id
    type
    createdAt
    displayName
    done
    completedOn
  }
}`;

export const GetClientSubscription = `query getClientSubscription($appId: String!) {
  getClientSubscription(appId: $appId) {
    plans {
      id
      description
      interval
      period
      slots
      amount
    }
    purchasedPlans {
      id
      createdAt
      slots
      interval
      period
      totalAmount
      refundId
      refundedOn
      receiptUrl
      assignedClients {
        clientId
        startDate
        assignedOn
      }
    }
    clients {
      id
      name
      email
      hasPremium
    }
  }
}`;

export const AssignClientSubscription = `mutation assignClientSubscription($purchaseId: String!, $clientId: String!, $startDate: String!) {
  assignClientSubscription(purchaseId: $purchaseId, clientId: $clientId, startDate: $startDate) {
    status
    message
  }
}`;

export const getTeamMembers = `query {
  listTeamMembers {
  id
    firstName
  lastName
  email
  cognitoId
  grantedRoles
  licenseType
  teamOwnerId
  licenseNo
  licenseExpires
  npiNo
  specialty
  }
}
`;

export const addTeamMember = `mutation addTeamMember($memberDetail: MemberDetailInput!, $grantedRoles: [RolesType!]!,$clinicianInfo: ClinicianInfoInput!) {
  addTeamMember(memberDetail: $memberDetail, grantedRoles: $grantedRoles ,clinicianInfo: $clinicianInfo) {
  id
    firstName
    lastName
    email
    grantedRoles
    licenseType
    licenseNo
    licenseExpires
    npiNo
    specialty
  }
}`;

export const editTeamMember = `mutation editTeamMember($id: String!, $memberDetail: MemberDetailInput!, $grantedRoles: [RolesType!]!,$clinicianInfo: ClinicianInfoInput!) {
  editTeamMember(id: $id, memberDetail: $memberDetail, grantedRoles: $grantedRoles ,clinicianInfo: $clinicianInfo) {
   id
   cognitoId
    firstName
    lastName
    email
    grantedRoles
    licenseType
    licenseNo
    licenseExpires
    npiNo
    specialty
  }
}`;

export const getInvoice = `query getInvoiceById($clientId: String!, $id: String!) {
    getInvoiceById(clientId: $clientId, id: $id) {
        createdAt
          id
          status
          billingType
          services {
            date
            totalAmount
            appointmentId
            serviceName
          }
          totalAmount
    }
}`;

export const getSuperbill = `query getSuperBillById($clientId: String!, $id: String!) {
    getSuperBillById(clientId: $clientId, id: $id) {
        id
          billingType
          createdAt
          services {
              date
              appointmentId
              totalAmount
              totalPaid
              services {
                  serviceCode
                  serviceName
                  serviceAmount
              }
          }
          totalAmount
    }
}`;

export const getStatement = `query getStatementById($clientId: String!, $id: String!) {
    getStatementById(clientId: $clientId, id: $id) {
        id
        clientId
        createdAt
        startDate
        endDate

        statement {
          ... on PreviousBalance {
            typeName
            description
            createdAt
            balance
        }

        ... on InvoiceStatement {
          typeName
          id
          billingType
          createdAt
          charges
          paid
          balance
          services {
            date
            totalAmount
            appointmentId
            serviceName
          }
        }

        ... on PaymentStatement {
          typeName
          createdAt
          paymentType
          charges
          paid
          balance
        }

        ... on EndingBalance {
          typeName
          description
          createdAt
          balance
      }
      }
    }
}`;
